// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loading_loaderContainer__1UUHl","loader":"Loading_loader__1nDrn","spin":"Loading_spin__168a7"};